/* JEUNESSE — all CTA buttons scroll to the product-information buy-box / quantity selector */
(function(){
  function headerOffset(){
    var h=document.querySelector('.section-header, header[role="banner"], .shopify-section-group-header-group');
    var hh=h?h.getBoundingClientRect().height:0;
    if(!hh||hh>160) hh=90;            /* sticky header reports a huge height — clamp */
    return hh+10;
  }
  function target(){
    return document.querySelector('#jns-buybox')
        || document.querySelector('.quantity-break, .lumin-quantity-break, [class*="quantity-break"]')
        || document.querySelector('product-form, .product-form')
        || document.querySelector('#MainContent .shopify-section');
  }
  function scrollToBuy(e){
    var t=target(); if(!t) return;
    if(e){e.preventDefault();}
    var y=t.getBoundingClientRect().top+window.pageYOffset-headerOffset();
    try{window.scrollTo({top:y,behavior:'smooth'});}catch(_){window.scrollTo(0,y);}
  }
  function bind(){
    document.querySelectorAll('[data-jns-scroll], a.jns-cta, button.jns-cta').forEach(function(b){
      if(b.__jns)return; b.__jns=1; b.addEventListener('click',scrollToBuy);
    });
  }
  if(document.readyState!=='loading')bind();else document.addEventListener('DOMContentLoaded',bind);
  document.addEventListener('shopify:section:load',bind);
})();
